import { CarBusinessLine } from "../../car/constants/car-basic-data";
import { Message } from "./message.model";

export class Conversation {
    id = 0;
    businessLine: CarBusinessLine = CarBusinessLine.BUY;
    carId = '';
    offerId = '';
    carDetails = '';
    offerDetails = '';
    participants: string[] = [];
    messages: Message[] = [];
  
    constructor ()  {
        this.messages = [];
        this.participants = [];
    }
}
